import React, { Component } from "react";
import { MyComplaintsProps } from "@my-dld/components/MyRequest/MyComplaintsListView";
import GridDataView, { GRID_SIZE } from "@my-dld/components/DataView/GridDataView";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { Complaint, TransactionStatusId } from "@eres/rvsapi/entities";
import Strings from "@my-dld/assets/strings";
import {
	getComplaintAuthority,
	getComplaintDate,
	getComplaintLicense,
	getComplaintStatus,
	getComplaintTransactionNo
} from "@my-dld/screens/MyDLD/MyRequest/MyComplaints";

interface State {
	searchKey?: string;
	page: number;
}

class MyComplaintsGridView extends Component<MyComplaintsProps, State> {
	constructor( props: MyComplaintsProps ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { isAnyClosed, items, onDetails } = this.props;
		const { searchKey } = this.state;
		const filterData = this.getFilterData( searchKey );
		return <GridDataView
			items={ this.getPageData( filterData ) }
			onSearch={ this.onSearch }
			renderGridItem={ ( item: Complaint ) => {
				return <RenderGridItem
					key={ "" + item.TransactionId }
					item={ item }
					onDetails={ onDetails }/>;
			} }
			totalCount={ !isEmptyStringOrNull( searchKey ) ? filterData.length : items.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getFilterData( sKey?: string ) {
		const { items } = this.props;
		if ( sKey ) {
			return items.filter( ( item: Complaint ) => {
				const filterKeys: string[] = [];
				filterKeys.push( getComplaintTransactionNo( item ) );
				filterKeys.push( getComplaintStatus( item ) );
				filterKeys.push( getComplaintDate( item ) );
				filterKeys.push( getComplaintLicense( item ) );
				filterKeys.push( getComplaintAuthority( item ) );
				const fItem = filterKeys.find( ( fKey: string ) => fKey.toLocaleLowerCase().includes( sKey.toLocaleLowerCase() ) );
				return fItem != undefined;
			} );
		}
		return items;
	}

	private getPageData( filterData: Complaint[] ) {
		const { page } = this.state;
		return filterData.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private onSearch = ( sKey?: string ) => {
		this.setState( {
			searchKey: sKey,
			page: 1
		} );
	};

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

function RenderGridItem( props: {
	item: Complaint, onDetails: ( complaint: Complaint ) => void,
	isAnyClosed?: boolean
} ) {
	const { item, onDetails, isAnyClosed } = props;
	const isClosed = item.TransactionStatusId === TransactionStatusId.Closed;
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getComplaintTransactionNo( item ) }</span>
							<span>{ Strings.transaction_number }</span>
						</div>
						<div className={ `property-status ${ isClosed ? "completed" : "submit" }` }>
							{ getComplaintStatus( item ) }
						</div>
					</div>
					<div className="row no-gutters property-card-detail col-item-3">
						<div className="col-6">
							<span>{ getComplaintDate( item ) }</span>
							<span>{ Strings.submission_date }</span>
						</div>
						<div className="col-6">
							<span>{ getComplaintLicense( item ) }</span>
							<span>{ Strings.license_number }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail col-item-3">
						<div className="col-12">
							<span>{ getComplaintAuthority( item ) }</span>
							<span>{ Strings.company_name }</span>
						</div>
					</div>
					{ isClosed && <div className="row no-gutters property-card-action">
						<div className="col-md-12">
							<button
								className="btn-link" onClick={ () => {
								onDetails( item );
							} }>{ Strings.view_details }</button>
						</div>
					</div> }
				</div>
			</div>
		</div>
	</div>;
}

export default MyComplaintsGridView;
